<template>
  <div class="search">
    <input class="search__input" type="text" v-model="localValue" :placeholder="placeholder" :class="{'viewOnly': locked}" >
    <svg-icon v-show="isSearchInputEmpty"
              class="search__search-icon"
              :icon="searchIcon" :width="14" :height="14"></svg-icon>
    <svg-icon v-show="!isSearchInputEmpty"
              @click.native="clearSearch"
              class="search__cancel-icon"
              :icon="cancelIcon" :width="10" :height="10"></svg-icon>
  </div>
</template>

<script>
  import { debounce } from 'lodash'
  import SvgIcon from '@/components/common/svgIcon'
  import searchIcon from '@/assets/svg/search.svg'
  import cancelIcon from '@/assets/svg/cancel.svg'

  export default {
    components: {
      SvgIcon
    },
    props: {
      value: {
        type: String
      },
      debounce: {
        type: Number,
        default: 0
      },
      placeholder: {
        type: String,
        default: ''
      },
      locked: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        localValue: '',
        searchIcon,
        cancelIcon
      }
    },
    computed: {
      isSearchInputEmpty () {
        return this.localValue.length === 0
      }
    },
    methods: {
      clearSearch () {
        this.localValue = ''
      }
    },
    beforeMount () {
      if (this.value) {
        this.localValue = this.value
      }
    },
    created () {
      /**
       *  Create a debounced function for emitting the input event using the debounce prop value
       */
      this._emitInputEventDebounced = debounce(function (newValue) {
        if (this.localValue === '') return
        this.$emit('input', newValue)
      }, this.debounce)

      /**
       * Watch the localValue property and if it isn't being cleared, call the debounced function
       * If it is being cleared, emit the input event immediately
       */
      this.$watch('localValue', function (newValue) {
        if (newValue.length) {
          this._emitInputEventDebounced(newValue)
        } else {
          this.$emit('input', newValue)
        }
      })
    }
  }
</script>

<style lang="scss">
  .search {
    position: relative;

    &__input {
      display: block;
      width: 100%;
      padding: 5px 40px 6px 10px;
      box-sizing: border-box;
      background-color: #ffffff;
      border-radius: 100px;
      border: 0;
      font-size: rem(14);
      transition: .1s ease-out;

      &:focus {
        outline: 0;
        box-shadow: 0 0 0 2px color(yellow);
      }

      // This removes the browser default 'X' button on the input in IE/Edge
      &::-ms-clear {
        display: none;
      }
    }
    
    .viewOnly {
      pointer-events: none;
    }

    &__search-icon {
      pointer-events: none;
    }

    &__search-icon,
    &__cancel-icon {
      position: absolute;
      top: 50%;
      right: 20px;
      transform: translateY(-50%);
      fill: color(grays, light);
    }

    &__cancel-icon {
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// SearchInput.vue?7e7e5cfe